import { Button, FormControl, InputLabel, MenuItem, Select, Stack } from '@mui/material';
import { AreaDetail } from '../../services/raiseRequest.services';

export function SelectArea({
  areas,
  selectedAreaIndex,
  setSelectedAreaIndex,
  setStep,
  setEditing,
  handleAreaSubmit,
}: {
  areas: AreaDetail[];
  selectedAreaIndex: number | null;
  setSelectedAreaIndex: any;
  setStep: any;
  setEditing: any;
  handleAreaSubmit: any;
}) {
  return (
    <>
      <FormControl fullWidth>
        <InputLabel id="select-area-label">Select Area</InputLabel>
        <Select labelId="select-area-label" id="select-area" label="Select Area">
          {areas?.map((area, index) => {
            return (
              <MenuItem onClick={() => setSelectedAreaIndex(index)} value={area.Area}>
                {`${area.Area}, ${area.Town}, ${area.City}, ${area.State} - ${area.PinCode}`}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
      <Stack direction={'row'} justifyContent={'flex-end'} gap={2}>
        <Button
          variant="outlined"
          onClick={() => {
            setStep(0);
            setEditing(false);
          }}
          sx={{ textTransform: 'none', ml: 2 }}
        >
          Cancel
        </Button>
        <Button
          disabled={selectedAreaIndex === null}
          variant="contained"
          onClick={handleAreaSubmit}
          sx={{ textTransform: 'none' }}
        >
          Next
        </Button>
      </Stack>
    </>
  );
}
